import gsap from "gsap";

export const animateAbout = () => {
  let timeline = gsap.timeline();

  timeline
    .from(".about--box-1", { x: -50, opacity: 0, duration: 0.5 })
    .from(".about--box-2", { x: -50, opacity: 0, duration: 0.5 });
};

export const animateMain = () => {
  let timeline = gsap.timeline();

  timeline
    .from(".hero--box-1", { x: -50, opacity: 0, duration: 0.5 })
    .from(".hero--box-2", { x: -50, opacity: 0, duration: 0.5 });
};
